/**
 * ImportModal Mini-Store
 *
 * Separate store for the import publications modal.
 * Reset on close via imperative dispatchImportModalCommand from the parent.
 */

import { createStore } from '@commandDrivenStateEngine/core/createStore';
import { initialState } from './state';
import { handlers } from './handlers';

const store = createStore({
  name: 'channels-import-modal',
  initialState,
  handlers
});

export const {
  useSelector: useImportModalSelector,
  useErrors: useImportModalErrors,
  useDispatch: useImportModalDispatch,
  usePolicies: useImportModalPolicies,
  getState: getImportModalState,
  dispatch: dispatchImportModalCommand
} = store;
